import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import React from 'react';
import { usePermissions } from '../../hooks/use-permissions';
import { NavDataSection } from './nav-data';
import { navRowSx } from './nav-row';
import { NavSectionLink } from './nav-section-link';

export function NavSection(props: {
  item: NavDataSection;
  open: boolean;
  handleOpen: () => void;
}) {
  // Props
  const { item, open } = props;
  // Hooks
  const { checkPermissions, checkBillingAccess, hasGroup } = usePermissions();

  let canView = true;
  if (item.hasGroup) {
    // User must have this specific group to view link
    canView = hasGroup(item.hasGroup);
  } else if (item.permissions) {
    // User must have one of the permissions
    canView = checkPermissions(item.permissions);
  }

  let hideFromBilling = false;
  if (item.name && item.access) {
    // Only Billing Navigation items with name and access will be hidden and checked
    hideFromBilling = !checkBillingAccess(item.name, item.access);
  }

  const isProd = process.env.REACT_APP_AWS_BRANCH === 'master';

  if (!hideFromBilling && canView) {
    return (
      <React.Fragment>
        <ListItem disablePadding>
          <ListItemButton
            aria-expanded={open}
            onClick={props.handleOpen}
            sx={navRowSx({ depth: 0 })}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.title} disableTypography />
            {open ? (
              <ExpandLessOutlined sx={{ fontSize: 20, color: '#00000099' }} />
            ) : (
              <ExpandMoreOutlined sx={{ fontSize: 20, color: '#00000099' }} />
            )}
          </ListItemButton>
        </ListItem>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" dense disablePadding>
            {item.links.map((link) => {
              if (isProd && link.hideFromProd) {
                return null;
              }
              return <NavSectionLink key={link.title} item={link} />;
            })}
          </List>
        </Collapse>
      </React.Fragment>
    );
  } else {
    return null;
  }
}
